import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useCustomDialogStyles = makeStyles()(() => ({
  paper: {
    position: 'absolute',
    width: '100%',
    borderRadius: '24px 24px 0 0',
    bottom: 0,
    margin: 0,
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  content: {
    padding: 0,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  hasYBorders: {
    borderTop: `1px solid ${hubloTheme.palette.tektiteLight.main}`,
    borderBottom: `1px solid ${hubloTheme.palette.tektiteLight.main}`,
    marginBottom: -1,
  },
  contentText: {
    color: hubloTheme.palette.tektiteBlack.main,
    padding: hubloTheme.spacing(1, 3),
  },
  actions: {
    padding: 0,
  },
  fullHeight: {
    minHeight: '98%',
  },
}))
